import { FC } from 'react'
import { Typography } from '@mui/material'
import { isBetaUIEnabled } from '$utils'

type LoadedPageLeftTitleProps = {
  text: string
}

const LoadedPageLeftTitle: FC<LoadedPageLeftTitleProps> = ({ text }) => {
  return (
    <Typography
      variant="h1"
      sx={{
        fontSize: '2em',
        color: isBetaUIEnabled() ? 'black' : 'text.primary',
      }}
    >
      {text}
    </Typography>
  )
}

export default LoadedPageLeftTitle
